export abstract class SmartTableData {
  abstract getData(): any[];
  abstract getPropertyData(): any[];
  abstract getLeases(): any[];
  abstract getInvoices(): any[];
}
